
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iO5PP", function(module, exports) {
"use strict";
var $db116c2f6bcc0f22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckCircle = void 0;

const $db116c2f6bcc0f22$var$react_1 = $db116c2f6bcc0f22$var$__importDefault((parcelRequire("acw62")));
const $db116c2f6bcc0f22$var$CheckCircle = ({ fill: fill = "none" })=>{
    if (fill === "filled") return $db116c2f6bcc0f22$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%"
    }, $db116c2f6bcc0f22$var$react_1.default.createElement("path", {
        fill: "currentColor",
        d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
    }));
    return $db116c2f6bcc0f22$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": true
    }, $db116c2f6bcc0f22$var$react_1.default.createElement("path", {
        d: "M5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16ZM16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM22.1905 13.7234C22.59 13.342 22.6047 12.709 22.2234 12.3095C21.842 11.91 21.209 11.8953 20.8095 12.2766L14.1666 18.6176L11.1905 15.7766C10.791 15.3953 10.158 15.41 9.77665 15.8095C9.39531 16.209 9.41002 16.842 9.80952 17.2234L13.4761 20.7234C13.8626 21.0922 14.4707 21.0922 14.8571 20.7234L22.1905 13.7234Z",
        fill: "currentColor"
    }));
};
module.exports.CheckCircle = $db116c2f6bcc0f22$var$CheckCircle;

});


//# sourceMappingURL=check-circle.0c09531e.js.map
